import { ParseAdapter } from '../abstract/ParseAdapter';
import { Tchekb } from './tchekb.model';

export class Device extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get companyName(): string { return this.parseObject.get('companyPtr') ? this.parseObject.get('companyPtr').get('name') : 'N.I.' }
    get companyAddress(): string { return this.parseObject.get('companyPtr') ? this.parseObject.get('companyPtr').get('address') : 'N.I.' }
    get companyIdentifier(): string { return this.parseObject.get('companyPtr') ? this.parseObject.get('companyPtr').get('identifier') : undefined }

    get lastLive(): Date { return this.parseObject.get('lastLive'); }
    set lastLive(value: Date) { this.parseObject.set('lastLive', value); }

    get camNumber(): number { return this.parseObject.get('camNumber'); }
    set camNumber(value: number) { this.parseObject.set('camNumber', value); }

    get dateMonitoring(): Date { return this.parseObject.get('dateMonitoring'); }
    set dateMonitoring(value: Date) { this.parseObject.set('dateMonitoring', value); }

    // TODO: implement company model
    get companyPtr(): any { return this.parseObject.get('companyPtr'); }
    set companyPtr(value: any) { this.parseObject.set('companyPtr', value); }

    get webObjectId(): string { return this.parseObject.get('webObjectId'); }
    set webObjectId(value: string) { this.parseObject.set('webObjectId', value); }

    get status(): boolean { return this.parseObject.get('status'); }
    set status(value: boolean) { this.parseObject.set('status', value); }

    get address(): string { return this.parseObject.get('address'); }
    set address(value: string) { this.parseObject.set('address', value); }

    get ipMachine(): string { return this.parseObject.get('ipMachine'); }
    set ipMachine(value: string) { this.parseObject.set('ipMachine', value); }

    get fromDistant(): boolean { return this.parseObject.get('fromDistant'); }
    set fromDistant(value: boolean) { this.parseObject.set('fromDistant', value); }

    get serialNumber(): string { return this.parseObject.get('serialNumber'); }
    set serialNumber(value: string) { this.parseObject.set('serialNumber', value); }

    get gpsLocation(): string { return this.parseObject.get('gpsLocation'); }
    set gpsLocation(value: string) { this.parseObject.set('gpsLocation', value); }

    get ngrok(): string { return this.parseObject.get('ngrok'); }
    set ngrok(value: string) { this.parseObject.set('ngrok', value); }

    getParseInstance(): Parse.Object {
        return Object.assign({}, this.parseObject);
    }

}



// WEBPACK FOOTER //
// ./src/app/model/device.model.ts